import { render, staticRenderFns } from "./logoUsuario.vue?vue&type=template&id=dea272be&scoped=true"
import script from "./logoUsuario.vue?vue&type=script&lang=js"
export * from "./logoUsuario.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "dea272be",
  null
  
)

export default component.exports